/**
 * article-custom.js
 * Add-to-cart loader for article product cards.
 */

(function () {
  function initArticleCartBtns() {
    var forms = document.querySelectorAll(
      '.article-product-content form[action="/cart/add"]'
    );

    forms.forEach(function (form) {
      if (form.dataset.cartLoaderInit) return;
      form.dataset.cartLoaderInit = '1';

      var btn = form.querySelector('.addcart_btn');
      if (!btn) return;

      btn.addEventListener('click', function (e) {
        // Prevent navigation to /cart, but let theme's handlers bubble up
        e.preventDefault();

        setLoading(btn);

        // Reset loader when theme signals cart update
        document.addEventListener('cart:refresh', function () {
          resetBtn(btn);
        }, { once: true });

        // Fallback: reset after 5s if cart:refresh never fires
        setTimeout(function () { resetBtn(btn); }, 5000);
      });
    });
  }

  function setLoading(btn) {
    if (btn.dataset.originalHtml) return;
    btn.dataset.originalHtml = btn.innerHTML;
    btn.classList.add('addcart_btn--loading');
    btn.innerHTML = '<span class="addcart-spinner"></span>';
    btn.style.pointerEvents = 'none';
  }

  function resetBtn(btn) {
    if (!btn.dataset.originalHtml) return;
    btn.innerHTML = btn.dataset.originalHtml;
    delete btn.dataset.originalHtml;
    btn.classList.remove('addcart_btn--loading');
    btn.style.pointerEvents = '';
  }

  document.addEventListener('DOMContentLoaded', function () {
    initArticleCartBtns();
  });
})();
